module.exports = __webpack_public_path__ + "img/menu_close.1a6bd23d.svg";